import React from "react";
import { motion } from "framer-motion";
import { HeartHandshake, Brain, LineChart, Cog } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [HeartHandshake, Brain, LineChart, Cog];

export default function CxApproach() {
  const { t } = useLang();

  return (
    <section id="cx" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 halo w-[600px] h-[600px] bg-[#007AFF]/15" />
      <div className="mx-auto max-w-7xl px-5 md:px-8 relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#00F0FF]">
            {t.cx.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-white">
            {t.cx.title}
          </h2>
          <p className="mt-5 max-w-2xl text-base text-[#8B95A5] leading-relaxed">
            {t.cx.sub}
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.cx.pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`cx-pillar-${i}`}
                className="relative rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 hover:border-[#00F0FF]/25 transition-colors"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-gradient-to-br from-[#0B101E] to-[#050810] text-[#00F0FF]">
                  <Icon className="h-4 w-4" />
                </span>
                <h3 className="mt-5 font-display text-lg text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-[#8B95A5] leading-relaxed">
                  {p.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
